import { render, staticRenderFns } from "./goods_switch_on_off.vue?vue&type=template&id=28321bab&scoped=true&"
import script from "./goods_switch_on_off.vue?vue&type=script&lang=ts&"
export * from "./goods_switch_on_off.vue?vue&type=script&lang=ts&"
import style0 from "./goods_switch_on_off.vue?vue&type=style&index=0&id=28321bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28321bab",
  null
  
)

export default component.exports